export default __webpack_public_path__ + "static/media/key.aa8be0ca.svg";